export function useCdnAsset() {
    const cdnUrl = import.meta.env.VITE_CDN_URL || ''

    function cdn(path) {
        return cdnUrl + path
    }

    return {
        cdn,
    }
}
